import { render, staticRenderFns } from "./ReceivingCustomerDetail.vue?vue&type=template&id=879564a4&"
import script from "./ReceivingCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./ReceivingCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingCustomerDetail.vue?vue&type=style&index=0&id=879564a4&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('879564a4')) {
      api.createRecord('879564a4', component.options)
    } else {
      api.reload('879564a4', component.options)
    }
    module.hot.accept("./ReceivingCustomerDetail.vue?vue&type=template&id=879564a4&", function () {
      api.rerender('879564a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/ReceivingCustomerDetail.vue"
export default component.exports